import { render, staticRenderFns } from "./member-audit-manag.vue?vue&type=template&id=6c047620"
import script from "./member-audit-manag.vue?vue&type=script&lang=js"
export * from "./member-audit-manag.vue?vue&type=script&lang=js"
import style0 from "./member-audit-manag.vue?vue&type=style&index=0&id=6c047620&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports